export const VERIFY_RESET_TOKEN = "VERIFY_RESET_TOKEN"
export const VERIFY_RESET_TOKEN_SUCCESS = "VERIFY_RESET_TOKEN_SUCCESS"
export const VERIFY_RESET_TOKEN_FAILED = "VERIFY_RESET_TOKEN_FAILED"
